var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVoxistAsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#XMLID_00000143582063716467232360000010428958843064653440_);}\n\t.st1{fill:url(#XMLID_00000176043176191655797760000016029070106765654965_);}\n\t.st2{fill:url(#XMLID_00000044148823495411110310000008942617432708370089_);}\n\t.st3{fill:url(#XMLID_00000058559495071630502300000011614019635062423698_);}\n\t.st4{fill:url(#XMLID_00000099632411609091723240000017480360883638161060_);}\n\t.st5{fill:url(#XMLID_00000020383501795621607000000005374625980022816426_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "top_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000168824978247846296370000000308229839244239503_",
    gradientUnits: "userSpaceOnUse",
    x1: 810.5291,
    y1: -346.5045,
    x2: 2092.5559,
    y2: 935.5225,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    style: {
      fill: "url(#XMLID_00000168824978247846296370000000308229839244239503_)"
    },
    d: "M1920.2,1113.5 c0,66.2-53.7,120-120,120c-66.3,0-120-53.7-120-120V812.8c0-66.2,53.7-120,120-120c66.3,0,120,53.8,120,120V1113.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000078742744086463322530000007690674243770942873_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.2946,
    y1: 429.73,
    x2: 1316.3217,
    y2: 1711.7568,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    style: {
      fill: "url(#XMLID_00000078742744086463322530000007690674243770942873_)"
    },
    d: "M367.8,1113.5 c0,66.2-53.7,120-120,120s-120-53.7-120-120V812.8c0-66.2,53.7-120,120-120s120,53.8,120,120L367.8,1113.5L367.8,1113.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000103264648518182256260000015564128323014383784_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.3532,
    y1: 235.6714,
    x2: 1510.3801,
    y2: 1517.6984,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    style: {
      fill: "url(#XMLID_00000103264648518182256260000015564128323014383784_)"
    },
    d: "M515.9,418.6 c0-66.2,53.7-120,120-120s120,53.8,120,120v1089.2c0,66.2-53.7,120-120,120s-120-53.7-120-120V418.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000132050859649959738920000016834167328142231967_",
    gradientUnits: "userSpaceOnUse",
    x1: 616.4703,
    y1: -152.4458,
    x2: 1898.4976,
    y2: 1129.5813,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    style: {
      fill: "url(#XMLID_00000132050859649959738920000016834167328142231967_)"
    },
    d: "M1292.2,418.6 c0-66.2,53.7-120,120-120c66.2,0,120,53.8,120,120v1089.2c0,66.2-53.7,120-120,120c-66.2,0-120-53.7-120-120V418.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000103987250792647302850000014690024833932019359_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.0347,
    y1: -0.01004455,
    x2: 1746.0618,
    y2: 1282.017,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    style: {
      fill: "url(#XMLID_00000103987250792647302850000014690024833932019359_)"
    },
    d: "M904,252 c0-66.2,53.7-120,120-120c66.3,0,120,53.8,120,120v1255.9c0,66.2-53.7,120-120,120s-120-53.7-120-120L904,252L904,252z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000163031455333454533060000008326481367178611344_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.253,
    y1: 433.7716,
    x2: 1312.2799,
    y2: 1715.7986,
    gradientTransform: "matrix(1 0 0 1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D7C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    style: {
      fill: "url(#XMLID_00000163031455333454533060000008326481367178611344_)"
    },
    d: "M1144,1507.9 c0,181.3-145.5,333.6-326.8,332.6c-20.6-0.1-40.7-2.2-60.3-6c-20.5-4.1-25.5-31.2-7.6-42.1c92.9-57.1,154.7-159.7,154.7-276.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVoxistAsr);
export default __webpack_public_path__ + "static/media/logo_voxist_asr.6c93e6ab0dd6663f8fd38052a4d39853.svg";
export { ForwardRef as ReactComponent };